module.exports = __webpack_public_path__ + "static/media/invoice-page-icon.7d623e81.svg";